export default __webpack_public_path__ + "static/media/S0020.34I-26481_-16320_0.1666270920000.16ec1828.jpg";